import * as React from "react";
import { SVGProps } from "react";
const SvgAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27.77 23.16 17.82 5a2.1 2.1 0 0 0-3.64 0L4.23 23.16A2 2 0 0 0 6.05 26h19.9a2 2 0 0 0 1.82-2.84ZM15 9.948a1 1 0 0 1 2 0v7a1 1 0 0 1-2 0v-7Zm1 13a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAlert;
